<template>
    <v-dialog
    v-model="localValue"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Nova lokacija
      </v-card-title>

      <v-card-text>
        <AppSpinner v-if="!loaded" />
        <LocationForm
          ref="locationForm"
          :modalView="true"
          :taxLevels="taxLevels"
          :taxTypes="taxTypes"
          @save="saveAndClose"
          @cancel="cancel"
          v-else
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import LocationForm from './LocationForm'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    LocationForm
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      loaded: false,
      localValue: this.value
    }
  },
  computed: {
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    }
  },
  methods: {
    ...mapActions('taxLevels', { loadTaxLevels: 'loadItems' }),
    ...mapActions('taxTypes', { loadTaxTypes: 'loadItems' }),
    saveAndClose (form) {
      this.$emit('input', false)
      this.$emit('confirmed', form)
    },
    cancel () {
      this.clearForm()
      this.$emit('input', false)
    },
    clearForm () {
      this.$refs.locationForm.clearForm()
    }
  },
  created () {
    Promise.all([
      this.loadTaxLevels(),
      this.loadTaxTypes()
    ])
      .then(items => { this.loaded = true })
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
